module.exports = __webpack_public_path__ + "website/img/main03.e083d427.jpg";